
import './App.css';

import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import 'bootstrap/dist/css/bootstrap.min.css';
import "@fortawesome/fontawesome-free/css/all.min.css";
import HeroSection from './componets/HeroSlider';
import Header from './componets/Header';
import Footer from './componets/Footer';
import AboutSection from './componets/AboutUs';
import TermsConditions from './pages/TermsConditions';
import PrivacyPolicy from './pages/PrivacyPolicy';
import ServicesGrid from './pages/ServicesGrid';
import Booking from './pages/Booking';
import Gallery from './pages/Gallery';
import ContactFeatures from './pages/ContactFeatures';
import Enquiry from './pages/Enquiry';
import Packages from './pages/Packages';
import Urbaniaonrentinpune from './pages/Urbania On Rent in Pune';
import ScrollToTop from './componets/ScrollToTop';
import Ourfleet from './pages/Ourfleet';
import Twentyfourseaterbusforrentinpune from './pages/24 Seater Bus for Rent in Pune';
import Onesixseterurbania from './pages/16 Seater Urbania for Rent in Pune';
import Onefourseaterurbaniahireinpune from './pages/14 Seater Urbania Hire in Pune';
import Onesevanurbaniahireinpune from './pages/17 Seater Urbania Hire in Pune';
import Minibusonrentinpimpri from './pages/Mini Bus on Rent in Pimpri Chinchwad';
import Minibusonrentinpune from './pages/Mini Bus On Rent in Pune';
import Forceurbaniasevenseater from './pages/Force Urbania 17 Seater On Rent in Pune';
import Thirtinfiveseateronrentinpune from './pages/35 Seater Bus On Rent in Pune';
import Fourfiveseaterbusonrentinpune from './pages/45 Seater Bus On Rent in Pune';
import Fivethreeseaterbusonrentinpune from './pages/53 Seater Bus On Rent in Pune';
import Fiftyseaterbusonrentinpune from './pages/50 Seater Bus On Rent in Pune';
import Busonrentinpune from './pages/Bus On Rent in Pune';
import Bushireinpune from './pages/Bus Hire in Pune';
import Busonrentinpimprichichwad from './pages/Bus On Rent in Pimpri Chinchwad';
import Busrentalsforcorporateeventsinpune from './pages/Bus Rental for Corporate Events in Pune';
import Weddingbusbookingonlinepune from './pages/Wedding Bus Booking Online Pune';
import Bushireforschooltripinpune from './pages/Bus Hire for School Trips in Pune';
import Bushireforpartyeventsinpune from './pages/Bus Hire for Party Events in Pune';
import Fullbusbookingformarriagepne from './pages/Full Bus Booking for Marriage Pune';
import Acluxurybusonrentinpune from './pages/AC Luxury Bus On Rent in Pune';
import Luxuryforceurbaniaonrentinpune from './pages/Luxury Force Urbania On Rent in Pune';
import Urbaniaonrentinpunefocorporate from './pages/Urbania On Rent in Pune for Corporate';
import Punetogoaurbaniaonrent from './pages/Pune to Goa Urbania On Rent';
import Punetomumbaiurbaniaonrent from './pages/Pune to Mumbai Urbania On Rent';
import Forceurbanialuxuryminibusonrent from './pages/Force Urbania Luxury Mini Bus On Rent';
import Punetomahabaleshwarurbaniaonrent from './pages/Pune to Mahabaleshwar Urbania On Rent';
import Onesevanseaterurbaniaonrentinpune from './pages/17 Seater Force Urbania on Rent in Pune';
import Urbaniahireforoutstationinpune from './pages/Urbania Hire for Outstation in Pune';
import Urbaniaonrentinpimprichichwad from './pages/Urbania On Rent in Pimpri Chinchwad';
import ContactButtons from './componets/ContactButtons';



function App() {
  return (
    <Router>
      <Header />
      <ContactButtons />
      <ScrollToTop />

      <Routes>
        <Route path="/" element={<HeroSection />} />
        <Route path="/about" element={<AboutSection />} />
        <Route path="/term-condition" element={<TermsConditions />} />
        <Route path="/our-fleet" element={<Ourfleet />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/services" element={<ServicesGrid />} />
        <Route path="/packages" element={<Packages />} />
        <Route path="/booking" element={<Booking />} />
        <Route path="/gallery" element={<Gallery />} />
        <Route path="/contact-us" element={<ContactFeatures />} />
        <Route path="/enquiry" element={<Enquiry />} />





<Route path="/24-seater-bus-for-rent-in-pune" element={<Twentyfourseaterbusforrentinpune />} />
<Route path="/16-seater-urbania-for-rent-in-pune" element={<Onesixseterurbania />} />
<Route path="/14-seater-urbania-hire-in-pune" element={<Onefourseaterurbaniahireinpune />} />
<Route path="/17-seater-urbania-hire-in-pune" element={<Onesevanurbaniahireinpune />} />
<Route path="/mini-bus-on-rent-in-pimpri-chinchwad" element={<Minibusonrentinpimpri />} />
<Route path="/mini-bus-on-rent-in-pune" element={<Minibusonrentinpune />} />
<Route path="/force-urbania-17-seater-on-rent-in-pune" element={<Forceurbaniasevenseater />} />
<Route path="/35-seater-bus-on-rent-in-pune" element={<Thirtinfiveseateronrentinpune />} />
<Route path="/45-seater-bus-on-rent-in-pune" element={<Fourfiveseaterbusonrentinpune />} />
<Route path="/53-seater-bus-on-rent-in-pune" element={<Fivethreeseaterbusonrentinpune />} />
<Route path="/50-seater-bus-on-rent-in-pune" element={<Fiftyseaterbusonrentinpune />} />
<Route path="/bus-on-rent-in-pune" element={<Busonrentinpune />} />
<Route path="/bus-hire-in-pune" element={<Bushireinpune />} />
<Route path="/bus-on-rent-in-pimpri-chinchwad" element={<Busonrentinpimprichichwad />} />
<Route path="/bus-rental-for-corporate-events-in-pune" element={<Busrentalsforcorporateeventsinpune />} />
<Route path="/wedding-bus-booking-online-pune" element={<Weddingbusbookingonlinepune />} />
<Route path="/bus-hire-for-school-trips-in-pune" element={<Bushireforschooltripinpune />} />
<Route path="/bus-hire-for-party-events-in-pune" element={<Bushireforpartyeventsinpune />} />
<Route path="/full-bus-booking-for-marriage-pune" element={<Fullbusbookingformarriagepne />} />
<Route path="/ac-luxury-bus-on-rent-in-pune" element={<Acluxurybusonrentinpune />} />
        <Route path="/urbania-on-rent-in-pune" element={<Urbaniaonrentinpune />} />

<Route path="/luxury-force-urbania-on-rent-in-pune" element={<Luxuryforceurbaniaonrentinpune />} />
<Route path="/urbania-on-rent-in-pune-for-corporate" element={<Urbaniaonrentinpunefocorporate />} />
<Route path="/pune-to-goa-urbania-on-rent" element={<Punetogoaurbaniaonrent />} />
<Route path="/pune-to-mumbai-urbania-on-rent" element={<Punetomumbaiurbaniaonrent />} />
<Route path="/force-urbania-luxury-mini-bus-on-rent" element={<Forceurbanialuxuryminibusonrent />} />
<Route path="/pune-to-mahabaleshwar-urbania-on-rent" element={<Punetomahabaleshwarurbaniaonrent />} />
<Route path="/17-seater-force-urbania-on-rent-in-pune" element={<Onesevanseaterurbaniaonrentinpune />} />
<Route path="/urbania-hire-for-outstation-in-pune" element={<Urbaniahireforoutstationinpune />} />
<Route path="/urbania-on-rent-in-pimpri-chinchwad" element={<Urbaniaonrentinpimprichichwad />} />



      </Routes>
      <Footer />
    </Router>
  );
}

export default App;
